<template>
  <div class="analystics_paga">
    <h3 class="title-page">
      {{ $t("analytics") }}
    </h3>
    <chart-warehouse :params="filter" />
    <div style="width: 500px; height: 500px">
      <GeolacationPicker />
    </div>
  </div>
</template>

<script>
// import VueTab from "@/components/ui/tab/VueTab";
import ChartWarehouse from "@/components/charts/warehouse/chart-warehouse/ChartWarehouse";
// import ReportExpirationMaterials from "@/components/charts/warehouse/dashboard-tables/ReportExpirationMaterials";
// import LatencyRequests from "@/components/charts/warehouse/dashboard-table-chart/LatencyRequests";
// import RadioButton from "@/components/ui/radio-button/RadioButton";
// import OrderTimeChart from "@/components/charts/order/OrderTimeChart";
// import InvalidProductReport from "@/components/charts/warehouse/invalid-product-report/InvalidProductReport";
// import DelaysReport from "@/components/charts/warehouse/delays-report/DelaysReport";
// import FrequentlyProducts from "@/components/charts/warehouse/frequently-products/FrequentlyProducts";
// import MaterialsThatEnd from "@/components/charts/warehouse/materials-that-end/MaterialsThatEnd";
// import OrderCategoryPieChart from "@/components/charts/order/OrderCategoryPieChart";
// import OrderItemStatusBarChart from "@/components/charts/order/OrderItemStatusBarChart";
// import OrderItemStatusLineChart from "@/components/charts/order/OrderItemStatusLineChart";
import { TIME_FILTER_TYPE } from "@/utils/constants";
import GeolacationPicker from "@/components/warehouse/GeolacationPicker.vue";
// import ContractStatusChart from "@/components/charts/contract/ContractStatusChart";

export default {
  data() {
    return {
      selectedTab: localStorage.getItem("selectedDashboardView") || "warehouse",
      filter: {
        toDate: new Date().toISOStringWithTimeZone(false),
        fromDate: new Date(
          `${new Date().getFullYear()}-01-01`
        ).toISOStringWithTimeZone(),
        dateType: "Year",
      },
    };
  },
  components: {
    GeolacationPicker,
    // ContractStatusChart,
    // MaterialsThatEnd,
    // FrequentlyProducts,
    // DelaysReport,
    // InvalidProductReport,
    // OrderTimeChart,
    // RadioButton,
    // LatencyRequests,
    // ReportExpirationMaterials,
    ChartWarehouse,
    // VueTab,
    // OrderItemStatusLineChart,
    // OrderItemStatusBarChart,
    // OrderCategoryPieChart,
  },
  methods: {
    onChangeTab(val) {
      localStorage.setItem("selectedDashboardView", val);
    },
    onInputFilterDate() {
      if (this.filter.fromDate && this.filter.toDate) {
        this.reInitByTime();
      }
    },
    onChangeFilterType(val) {
      if (val !== TIME_FILTER_TYPE.allTime) {
        this.filter = {
          ...this.filter,
          toDate: null,
          fromDate: null,
        };
      } else {
        this.filter = {
          ...this.filter,
          fromDate: `${new Date().getFullYear()}-01-01T00:00:00+0500`,
          toDate: new Date().toISOStringWithTimeZone(false),
        };
      }
      this.$nextTick(() => {
        this.reInitByTime();
      });
    },
    reInitByTime() {
      const charts = {
        warehouse: [
          "expirationMaterials",
          /*'latencyRequest',*/ "invalidProductReport",
          "delaysReport",
        ],
        order: ["orderTimeChart", "orderCategoryPieChart"],
        contract: ["contractStatusChart"],
      };
      if (charts[this.selectedTab]) {
        charts[this.selectedTab].forEach((item) => {
          const /**
             * @type Object
             * @property reInit {function}
             */
            component = this.$refs[item];
          if (component && component.reInit) {
            component.reInit();
          }
        });
      }
    },
  },
  computed: {
    allTabs() {
      return [
        {
          text: this.$t("warehouses"),
          value: "warehouse",
        },
        {
          text: this.$t("orders"),
          value: "order",
        },
        {
          text: this.$t("contracts"),
          value: "contract",
        },
      ];
    },
    TIME_FILTER_TYPE: () => TIME_FILTER_TYPE,
    dateTags() {
      return Object.entries(TIME_FILTER_TYPE).map(([key, value]) => {
        return {
          name: this.$t(key),
          value,
        };
      });
    },
  },
};
</script>
